import React from "react";
import { WHY_US } from "../mock/mock";

export default function WhyUs() {
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-14">
          <p className="section-line text-gold mb-4">Why VIIMII</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            Why clients choose us <span className="gold-gradient-text italic">over others.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WHY_US.map((w, i) => (
            <div
              key={w.n}
              className="reveal group p-7 rounded-[26px] border hairline bg-viimii-2 hover:-translate-y-1 transition-transform duration-300"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <div className="font-display text-4xl text-cream/15 group-hover:text-gold transition-colors duration-300" style={{ }}>
                {w.n}
              </div>
              <h3 className="font-display text-xl text-cream mt-3 mb-2">{w.title}</h3>
              <p className="text-sm text-cream/60 leading-relaxed">{w.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
